import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import { TeamField } from '@modules/team/team-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';
import DateModelField from '@shared/fields/date-model-field';
import PhoneField from '@shared/fields/phone-field';
import EmailField from '@shared/fields/email-field';

function label(name) {
  return i18n(`entities.coach.fields.${name}`);
}

// function enumeratorLabel(name, value) {
//   return i18n(`entities.coach.enumerators.${name}.${value}`);
// }

const fields = ({ dateFormat, timeFormat }) => ({
  id: new IdField('id', label('id')),
  teams: TeamField.relationToMany('teams', label('teams'), { required: true }),
  name: new StringField('name', label('name')),
  firstName: new StringField('firstName', label('firstName'), { "required": true }),
  lastName: new StringField('lastName', label('lastName'), { "required": true }),
  birthdate: new DateModelField('birthdate', label('birthdate'), { "required": true, dateFormat }),
  email: new EmailField('email', label('email'), { required: true }),
  phoneNumber: new PhoneField('phoneNumber', label('phoneNumber')),
  gender: new EnumeratorField('gender', label('gender'), getSharedEnumeratorField('gender'), { required: true }),
  country: new EnumeratorField('country', label('country'), getSharedEnumeratorField('country'), { required: true }),
  type: new EnumeratorField('type', label('type'), getSharedEnumeratorField('coachType'), { required: true }),
  lastLogin: new DateTimeField('lastLogin', label('lastLogin'), { dateFormat, timeFormat }),
  createdAt: new DateTimeField('createdAt', label('createdAt'), { dateFormat, timeFormat }),
  updatedAt: new DateTimeField('updatedAt', label('updatedAt'), { dateFormat, timeFormat }),
  createdAtRange: new DateTimeRangeField('createdAtRange', label('createdAtRange')),
});

export class CoachModel extends GenericModel {
  constructor({ dateFormat, timeFormat } = {}) {
    super();

    this.dateFormat = dateFormat;
    this.timeFormat = timeFormat;
  }

  fields() {
    const { dateFormat, timeFormat } = this;
    return fields({ dateFormat, timeFormat });
  }

  presenter(row, fieldName) {
    const fields = this.fields();

    if (!fields[fieldName]) {
      throw new Error(`${fieldName} not found`);
    }

    return fields[fieldName].forPresenter(
      row[fields[fieldName].name],
    );
  }
}
